import { User } from 'features/auth/domain/entities/User'

// This is the frontend's vocabulary of gate-able actions/pages — kept as a union so every
// hasPermission() call site is compile-time checked against a known permission name. It is
// NOT the source of truth for who has what: that comes from `user.permissions`, populated
// from GET /api/v1/me, which reflects the actual Keycloak composite roles configured on the
// backend (see /api/v1/admin/roles/{role}/permissions). A user only passes a check here if
// the backend actually granted that permission string — there is no local role->permission
// table left to fall back on, so an unrecognized/missing permission fails closed (denied).
export type Permission =
  | 'manage_users'
  | 'view_user_management'
  | 'edit_catalogue'
  | 'view_catalogue'
  | 'record_offline_payments'
  | 'approve_payments'
  | 'view_payments'
  | 'approve_kyc'
  | 'view_kyc'
  | 'update_order_status'
  | 'view_orders'
  | 'update_dispatch'
  | 'view_dispatch'
  | 'delegate_grievances'
  | 'resolve_grievances'
  | 'view_grievances'
  | 'view_farmer_sales'
  | 'view_settings'
  | 'manage_settings'
  | 'view_revenue'
  | 'export_sales_reports'

export const hasPermission = (user: User | undefined | null, permission: Permission): boolean => {
  if (!user) return false
  return user.permissions.includes(permission)
}
